import { Sprite } from 'three';

import { createBadgeSprite } from '../marker-sprites';

/** `userData.type` of the container group holding every explore bubble. */
export const EXPLORE_MARKER_GROUP_TYPE = 'explore-markers';
/** `userData.type` of one bubble — a hit target, so the raycaster must not skip it. */
export const EXPLORE_MARKER_TYPE = 'explore-marker';

/** What a bubble points at. The app picks the panel it opens from this. */
export type ExploreMarkerCategory = 'surround' | 'appliance' | 'countertop';

export const EXPLORE_MARKER_CATEGORIES: Array<ExploreMarkerCategory> = ['surround', 'appliance', 'countertop'];

/** Scene units (inches) across the bubble */
export const EXPLORE_MARKER_SIZE = 8;

const FILL: Record<ExploreMarkerCategory, string> = {
	surround: '#E8622A',
	appliance: '#23c9ff',
	countertop: '#9b7bd4'
};

/** A camera-facing `+` bubble, coloured by what it opens. */
export const createExploreMarkerSprite = (category: ExploreMarkerCategory): Sprite => createBadgeSprite({
	label: '+',
	fill: FILL[category] ?? FILL.appliance,
	size: EXPLORE_MARKER_SIZE,
	renderOrder: 997
});
